/**
 * Material-UI styles for Device Import Dialog.
 * Defines layout, spacing, and visual styling for all dialog components.
 */
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    dialogTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: theme.spacing(1, 2),
    },
    fileRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    fileName: {
        flex: 1,
        padding: theme.spacing(1),
        border: `1px dashed ${theme.palette.divider}`,
        borderRadius: 4,
        minHeight: 36,
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.text.secondary,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    helpSection: {
        marginBottom: theme.spacing(2),
        fontSize: '0.85rem',
    },
    helpTitle: {
        fontWeight: 600,
        marginBottom: theme.spacing(0.5),
    },
    helpList: {
        margin: theme.spacing(0.5, 0),
        paddingLeft: theme.spacing(3),
    },
    feedbackArea: {
        maxHeight: 400,
        overflow: 'auto',
    },
    errorItem: {
        fontSize: '0.85rem',
        padding: theme.spacing(0.25, 0),
    },
    successMessage: {
        fontWeight: 500,
    },
    partialMessage: {
        fontWeight: 500,
    },
    failedMessage: {
        fontWeight: 500,
    },
}));
